import React, { useState, useMemo } from 'react';
import { ScenarioSessionDropdownProps, ISelectedState, IOption } from './types';
import OptionDropdown from './OptionDropdown';
import './styles.scss';

export default function ScenarioSessionDropdown(props: ScenarioSessionDropdownProps){
  const [open, setOpen] = useState(false);
  const onSelect = (option: IOption) => {
    props.onSelect(option);
    setOpen(false);
  };
  
  const onOpen = () => {
    setOpen(true);
  }
  
  const Options = useMemo(() => {
    return [{ label: '', value: null },...props.options]
  },[props.options])
  
  return (
    <div className={`ScenarioSessionDropdown`}>
      <label>Set scenario</label>
      <ul 
        className={`${open ? 'open' : 'close'}`}
      >
        {
          open
            ? Options.map((option) => 
              <OptionDropdown
                active={props.selected && option.value === props.selected.value}
                label={option.label}
                onClick={() => onSelect(option)}
                key={option.label}
              />
            )
          : <OptionDropdown
              active={false}
              label={props.selected && props.selected.label} 
              onClick={() => onOpen()}  
            />
        }
      </ul>
    </div>
)};
